import {
    Modal,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    ModalCloseButton,
    ModalFooter,
    Button,
    ModalBody
  } from "@chakra-ui/react";
  import useScreenType from "react-screentype-hook";
  import ReactPlayer from "react-player/youtube";
  import { Tabs } from '../../Components/Tabs/Tabs';
import { customTabsSpacing, dividerStyle, labelStyle } from "../SuggestedForYou/styles";

  const TutorialModal = ({ isOpen, onClose }) => {
    const { isMobile } = useScreenType();
  
    return (
      <Modal
        size={isMobile ? "full" : "4xl"}
        onClose={onClose}
        isOpen={isOpen}
        scrollBehavior={"inside"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Ignite Tutorials</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Tabs<"Sign up" | "Goals and metrics">
                customDividerStyle={dividerStyle}
                customTabLabelStyle={labelStyle}
                customTabsSpacing={customTabsSpacing}
                defaultSelectedTab={"Sign up"}
                tabs={[{label: "Sign up",  component:  <ReactPlayer url="https://youtu.be/1bImrsd0RP0?si=Pp25FnlB5JXJtmv8" width="100%" height="480px"/>}, {label: "Goals and metrics", component: <ReactPlayer url="https://youtu.be/9laAhIAOdDk?si=C-_xcmRCC0JUKdW1" width="100%" height="480px" />}]} 
            />
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>Close</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  };
  
  export default TutorialModal;
  